import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=1815f9fd&scoped=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=ts"
export * from "./DashboardNavbar.vue?vue&type=script&lang=ts"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=1815f9fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815f9fd",
  null
  
)

export default component.exports